import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 360,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const DeleteModal = ({
    open,
    handleClose,
    title,
    message,
    onDelete,
    isLoading = false
}) => {
    return (
        <Modal
            open={open}
            onClose={isLoading ? undefined : handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {title}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    {message}
                </Typography>
                <div className=' mt-4 space-x-3'>
                    <Button 
                        onClick={onDelete} 
                        variant="outlined" 
                        color="error"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <span className="flex items-center gap-2">
                                <CircularProgress size={20} color="inherit" />
                                Deleting
                            </span>
                        ) : (
                            'Delete'
                        )}
                    </Button>
                    <Button 
                        variant="contained" 
                        onClick={handleClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                </div>
            </Box>
        </Modal>
    )
}

export default DeleteModal